import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    clipRule="evenodd"
    d="M18.3333 6.00037H5.66676L12 10.7503L18.3333 6.00037ZM4 7.2503V17.0004C4 17.5527 4.44772 18.0004 5 18.0004H19C19.5523 18.0004 20 17.5527 20 17.0004V7.25034L12.6 12.8003C12.2445 13.067 11.7556 13.067 11.4 12.8003L4 7.2503ZM2 7.00037C2 5.34351 3.34315 4.00037 5 4.00037H19C20.6569 4.00037 22 5.34351 22 7.00037V17.0004C22 18.6572 20.6569 20.0004 19 20.0004H5C3.34315 20.0004 2 18.6572 2 17.0004V7.00037Z"
    fillRule="evenodd"
  />,
  'LetterIcon',
)
